import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1662.17776,0 L1662.17776,1359.96362 L1013.47511,1359.96362 L453.321206,1920.11752 L453.321206,1359.96362 L0,1359.96362 L0,0 L1662.17776,0 Z M1511.07069,151.107069 L151.107069,151.107069 L151.107069,1208.85655 L604.428275,1208.85655 L604.428275,1555.34506 L950.916784,1208.85655 L1511.07069,1208.85655 L1511.07069,151.107069 Z M906.79352,755.550454 L906.79352,873.079027 L453.321206,873.079027 L453.321206,755.550454 L906.79352,755.550454 Z M1208.85655,453.18521 L1208.85655,570.713782 L453.321206,570.713782 L453.321206,453.18521 L1208.85655,453.18521 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCommentLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCommentLine, _Component);

  var _super = _createSuper(IconCommentLine);

  function IconCommentLine() {
    _classCallCheck(this, IconCommentLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCommentLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconComment",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCommentLine.displayName = "IconCommentLine";
  return IconCommentLine;
}(Component);

IconCommentLine.glyphName = 'comment';
IconCommentLine.variant = 'Line';
IconCommentLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCommentLine;
export { IconCommentLine };